// Colocated strings for DashboardShell (SKILL.md rule 11, PLATFORM.md §6 decision 15).
// Consumed by the SFC as `useComponentI18n(messages)` from `@rdrive/i18n`, i.e. a LOCAL
// composer with the warn flags off: these keys resolve here and never touch the app's bundle.
//
// Where they came from (IA_ABSORPTION_PLAN Phase 1 step 6b-1, project-overview's App):
//   - `switchTheme` was the app's own key (`apps/project-overview/src/locales/`): its 10
//     translations are copied here VERBATIM and the key left the app with the menu entry.
//   - every other key was HARDCODED ENGLISH in App/component.vue — the theme name passed into
//     `switchTheme` ('Light' / 'Dark'), Fullscreen / Exit Fullscreen, DuckDB Query and the
//     missing-params dialog (title, sentence, Close). So every locale file carries the ENGLISH
//     text on purpose: each locale renders exactly what it rendered before (translation debt,
//     PLATFORM.md §7). Replace a file's values as translations land. `vi` (the 11th locale,
//     2026-10-28) shipped translated — "DuckDB" kept; `themeLight`/`themeDark` lower case, as
//     they only ever fill `switchTheme`'s `{theme}` mid-sentence.
import de from './de.json';
import en from './en.json';
import fr from './fr.json';
import it from './it.json';
import nl from './nl.json';
import pl from './pl.json';
import ptBR from './pt-BR.json';
import th from './th.json';
import vi from './vi.json';
import zhHans from './zh-Hans.json';
import zhHant from './zh-Hant.json';

export default {
  de,
  en,
  fr,
  it,
  nl,
  pl,
  'pt-BR': ptBR,
  th,
  vi,
  'zh-Hans': zhHans,
  'zh-Hant': zhHant,
};
